import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import api from "@/services/api";

Vue.use(Vuex);

const moduleAuth = {
    namespaced: true,
    state: () => ({
        token: '',
        refreshTokenStr: '',
        username: '',
        avatarURL: '',
        isLoggedIn: false,
    }),
    mutations: {
        LOGIN_SUCCESS(state, response) {
            state.token = response.access_token;
            state.refreshTokenStr = response.refresh_token;

            const user = response.user;
            state.username = user.display_name || user.username || user.Username;
            state.avatarURL = user.avatar_url || `https://ui-avatars.com/api/?name=${state.username}&background=random`;
            state.isLoggedIn = true;
        },
        LOGOUT(state) {
            state.token = '';
            state.refreshTokenStr = '';
            state.username = '';
            state.avatarURL = '';
            state.isLoggedIn = false;
        },
        REFRESH_TOKEN_SUCCESS(state, response) {
            state.token = response.access_token;
            state.refreshTokenStr = response.refresh_token;
        }
    },
    actions: {
        loginSuccess({ commit }, payload) {
            commit("LOGIN_SUCCESS", payload);
        },
        logout({ commit }) {
            commit("LOGOUT");
        },
        async refreshToken({ commit, state, dispatch }) {
            try {
                const response = await api.post('/auth/refresh', {
                    refresh_token: state.refreshTokenStr
                });
                if (response.data.access_token) {
                    commit("REFRESH_TOKEN_SUCCESS", response.data);
                    return response.data.access_token;
                } else {
                    throw new Error("No token");
                }
            } catch (error) {
                dispatch("logout");
                throw error;
            }
        }
    }
}

const pageStatusCache = {
    namespaced: true,
    state: () => ({
        language: "es",
        landingShows: { scroll: 0, response: null },
        landingBooks: { scroll: 0, response: null }
    }),
    mutations: {
        updateStatus(state, req) {
            state.landingShows.scroll = req.pos;
            state.landingShows.response = req.response;
        },
        setLanguage(state, lang) {
            state.language = lang;
        }
    }
}

const store = new Vuex.Store({
    modules: {
        auth: moduleAuth,
        pageStatus: pageStatusCache
    },
    plugins: [createPersistedState({ paths: ["auth.token", "auth.refreshTokenStr", "auth.avatarURL", "auth.username", "auth.isLoggedIn", "pageStatus.language"] })]
})

export default store;